/* Sports Circuit - racket comparison (up to 5)
   Independent of the theme's built-in compare feature: different storage key,
   different class names, no jQuery. */
(function () {
  'use strict';

  var KEY = 'scCompareItems';
  var CFG = { max: 5, sectionId: 'sc-compare-column', rows: [] };

  var cfgEl = document.getElementById('scCompareConfig');
  if (cfgEl) {
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { /* keep defaults */ }
  }
  var MAX = CFG.max || 5;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var bar = document.getElementById('scCompareBar');
  var slots = document.getElementById('scCompareSlots');
  var countEl = document.getElementById('scCompareCount');
  var openBtn = document.getElementById('scCompareOpen');
  var clearBtn = document.getElementById('scCompareClear');
  var drawer = document.getElementById('scCompareDrawer');
  var body = document.getElementById('scCompareBody');
  var diffOnly = document.getElementById('scCompareDiffOnly');

  if (!bar || !drawer) return;

  /* ---------- state ---------- */

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (i) { return i && i.h; }).slice(0, MAX);
    } catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* private mode */ }
  }

  var items = read();

  function indexOf(handle) {
    for (var i = 0; i < items.length; i++) { if (items[i].h === handle) return i; }
    return -1;
  }

  /* ---------- toast ---------- */

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('scCompareToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'scCompareToast';
      el.className = 'sc-cmp-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- reading a product off the page ---------- */

  function titleFor(input) {
    var card = input.closest('.product-card, .js-product-card, .card, li, .grid__item');
    if (card) {
      var link = card.querySelector('.product-card__name, .card__heading a, .product-card__title a, a[href*="/products/"]');
      if (link && link.textContent.trim()) return link.textContent.trim();
    }
    if (document.body.classList.contains('template-product') || window.location.pathname.indexOf('/products/') !== -1) {
      var h1 = document.querySelector('.product__title, .product-single__title, h1');
      if (h1 && h1.textContent.trim()) return h1.textContent.trim();
    }
    return null;
  }

  function imageFor(input) {
    var card = input.closest('.product-card, .js-product-card, .card, li, .grid__item');
    var img = card && card.querySelector('img');
    if (!img) img = document.querySelector('.product__media img, .product-single__photo img');
    if (!img) return null;
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
  }

  function prettify(handle) {
    return handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ---------- bar ---------- */

  function renderBar() {
    countEl.textContent = items.length;
    bar.hidden = items.length === 0;
    document.body.classList.toggle('sc-cmp-bar-open', items.length > 0);
    openBtn.disabled = items.length < 2;
    openBtn.title = items.length < 2 ? 'Pick at least two rackets to compare' : '';

    slots.innerHTML = '';
    for (var i = 0; i < MAX; i++) {
      var item = items[i];
      var slot = document.createElement('div');
      slot.className = 'sc-cmp-slot' + (item ? ' is-filled' : ' is-empty');
      if (item) {
        var img = item.i
          ? '<img src="' + esc(item.i) + '" alt="" loading="lazy">'
          : '<span class="sc-cmp-slot__ph"></span>';
        slot.innerHTML =
          img +
          '<span class="sc-cmp-slot__name">' + esc(item.t || prettify(item.h)) + '</span>' +
          '<button type="button" class="sc-cmp-slot__remove" data-remove="' + esc(item.h) + '" aria-label="Remove ' + esc(item.t || item.h) + '">&times;</button>';
      } else {
        slot.innerHTML = '<span class="sc-cmp-slot__ph"></span><span class="sc-cmp-slot__name sc-cmp-slot__name--empty">Add a racket</span>';
      }
      slots.appendChild(slot);
    }
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncChecks() {
    var boxes = document.querySelectorAll('.sc-cmp-check');
    for (var i = 0; i < boxes.length; i++) {
      var on = indexOf(boxes[i].getAttribute('data-handle')) !== -1;
      boxes[i].checked = on;
      var label = boxes[i].closest('.sc-cmp-toggle');
      if (label) label.classList.toggle('is-added', on);
    }
  }

  function refresh() {
    write(items);
    renderBar();
    syncChecks();
    if (!drawer.hidden) build();
  }

  /* ---------- toggling ---------- */

  function toggle(input) {
    var handle = input.getAttribute('data-handle');
    if (!handle) return;
    var at = indexOf(handle);
    if (at !== -1) {
      items.splice(at, 1);
    } else {
      if (items.length >= MAX) {
        input.checked = false;
        toast('You can compare up to ' + MAX + ' rackets. Remove one first.');
        return;
      }
      items.push({ h: handle, t: titleFor(input), i: imageFor(input) });
    }
    refresh();
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('.sc-cmp-check') : null;
    if (input) toggle(input);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-remove]');
    if (rm) {
      var at = indexOf(rm.getAttribute('data-remove'));
      if (at !== -1) { items.splice(at, 1); refresh(); }
      if (items.length === 0) close();
      return;
    }
    if (e.target.closest && e.target.closest('[data-sc-close]')) close();
  });

  clearBtn.addEventListener('click', function () { items = []; refresh(); close(); });
  openBtn.addEventListener('click', function () { open(); });
  if (diffOnly) diffOnly.addEventListener('change', function () { applyDiffOnly(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ---------- drawer ---------- */

  function open() {
    if (items.length < 2) { toast('Pick at least two rackets to compare.'); return; }
    drawer.hidden = false;
    document.body.classList.add('sc-cmp-locked');
    build();
  }

  function close() {
    drawer.hidden = true;
    document.body.classList.remove('sc-cmp-locked');
  }

  var cache = {};

  function fetchColumn(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var url = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?section_id=' + CFG.sectionId;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var col = doc.querySelector('.sc-cmp-col');
        if (!col) throw new Error('no column');
        cache[handle] = col;
        return col;
      });
  }

  function build() {
    body.innerHTML = '<div class="sc-cmp-loading">Loading comparison…</div>';
    var handles = items.map(function (i) { return i.h; });

    Promise.all(handles.map(function (h) {
      return fetchColumn(h).catch(function () { return null; });
    })).then(function (cols) {
      var pairs = [];
      cols.forEach(function (col, idx) {
        if (col) pairs.push({ handle: handles[idx], col: col });
      });

      if (!pairs.length) {
        body.innerHTML = '<div class="sc-cmp-empty">These rackets could not be loaded. Please refresh and try again.</div>';
        return;
      }

      var table = document.createElement('table');
      table.className = 'sc-cmp-table';

      var thead = document.createElement('thead');
      var headRow = document.createElement('tr');
      var corner = document.createElement('th');
      corner.className = 'sc-cmp-table__corner';
      corner.scope = 'col';
      headRow.appendChild(corner);

      pairs.forEach(function (p) {
        var th = document.createElement('th');
        th.scope = 'col';
        th.className = 'sc-cmp-table__product';
        var head = p.col.querySelector('.sc-cmp-col__head');
        if (head) th.appendChild(head.cloneNode(true));
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'sc-cmp-table__remove';
        rm.setAttribute('data-remove', p.handle);
        rm.setAttribute('aria-label', 'Remove from comparison');
        rm.innerHTML = '&times;';
        th.appendChild(rm);
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      var tbody = document.createElement('tbody');
      CFG.rows.forEach(function (row) {
        var values = pairs.map(function (p) {
          var cell = p.col.querySelector('[data-row="' + row.key + '"]');
          return cell ? cell.innerHTML.trim() : '';
        });

        var hasAny = values.some(function (v) { return v !== ''; });
        if (!hasAny) return;

        var plain = values.map(function (v) {
          var d = document.createElement('div');
          d.innerHTML = v;
          return d.textContent.trim().toLowerCase();
        });
        var same = plain.every(function (v) { return v === plain[0]; });

        var tr = document.createElement('tr');
        tr.className = 'sc-cmp-table__row';
        tr.setAttribute('data-same', same ? 'true' : 'false');

        var th = document.createElement('th');
        th.scope = 'row';
        th.className = 'sc-cmp-table__label';
        th.textContent = row.label;
        tr.appendChild(th);

        values.forEach(function (v) {
          var td = document.createElement('td');
          td.className = 'sc-cmp-table__value';
          td.innerHTML = v !== '' ? v : '<span class="sc-cmp-dash">—</span>';
          tr.appendChild(td);
        });

        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      body.innerHTML = '';
      var scroller = document.createElement('div');
      scroller.className = 'sc-cmp-scroller';
      scroller.style.setProperty('--sc-cmp-cols', pairs.length);
      scroller.appendChild(table);
      body.appendChild(scroller);
      applyDiffOnly();
    });
  }

  function applyDiffOnly() {
    var on = diffOnly && diffOnly.checked;
    var rows = body.querySelectorAll('.sc-cmp-table__row');
    var hidden = 0;
    for (var i = 0; i < rows.length; i++) {
      var same = rows[i].getAttribute('data-same') === 'true';
      var hide = on && same;
      rows[i].hidden = hide;
      if (hide) hidden++;
    }
    var note = body.querySelector('.sc-cmp-diffnote');
    if (note) note.remove();
    if (on && hidden && rows.length) {
      var p = document.createElement('p');
      p.className = 'sc-cmp-diffnote';
      p.textContent = hidden + ' identical row' + (hidden === 1 ? '' : 's') + ' hidden.';
      body.appendChild(p);
    }
  }

  /* ---------- product page button ---------- */

  function mountProductButton() {
    var tpl = document.getElementById('scCompareProductButton');
    if (!tpl || document.querySelector('.sc-cmp-toggle--product')) return;
    var node = tpl.content ? tpl.content.cloneNode(true) : null;
    if (!node || !node.querySelector('.sc-cmp-check')) return;
    var anchor = document.querySelector(
      '.product-form__buttons, .product-form, .product-single__form, .shopify-payment-button, .product__info-wrapper form[action*="/cart/add"]'
    );
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.className = 'sc-cmp-product-mount';
    wrap.appendChild(node);
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  /* ---------- init ---------- */

  function init() {
    renderBar();
    syncChecks();
    mountProductButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { syncChecks(); mountProductButton(); });
  document.addEventListener('scCompare:refresh', function () { syncChecks(); });

  window.scCompare = { open: open, close: close, clear: function () { items = []; refresh(); }, sync: syncChecks };
})();
